import { Component, Input, OnInit } from '@angular/core';
import { AuthUserService, AuthService } from 'acl-cloud-lib';
import { MachineOwner, User } from '../../../api/generated';
import { takeUntil } from 'rxjs';
import { BaseComponent } from '../../core/abstract/base.component';
import { environment } from '../../../environments/environment';
import { TranslateWithFallbackPipe } from 'acl-cloud-lib';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-user-panel',
  templateUrl: 'user-panel.component.html',
  styleUrls: ['./user-panel.component.scss'],
})
export class UserPanelComponent extends BaseComponent implements OnInit {
  menuItems: any = [
    {
      text: 'Profile',
      textKey: 'menu-profile',
      icon: 'user',
      onClick: () => {
        window.open(`${environment.baseAclUrl}/#/profile`, '_blank');
      }
    },
    {
      text: 'Home',
      textKey: 'menu-home',
      icon: 'info',
      onClick: () => {
        this._router.navigate(['/home'])
      },

    },
    {
      beginGroup: true,
      text: 'Logout',
      textKey: 'menu-logout',
      icon: 'runner',
      onClick: () => {
        this._authService.logout();
      }
    }
  ];
  @Input() menuMode!: string;
  username: string = '';

  constructor(
    private authService: AuthUserService<User, MachineOwner>,
    private readonly _translate: TranslateWithFallbackPipe,
    private readonly _authService: AuthService,
    private readonly _router: Router
  ) {
    super();
  }

  ngOnInit(): void {
    this.authService.userDetail$.pipe(takeUntil(this.unSubscriber)).subscribe(val => {
      this.username = val?.Name ?? '';
    });
  }

  public initMenuItems(): void {
    this.menuItems.forEach((item: any) => item.text = this._translate.transform(item.textKey));
  }
}
